export const apiDateFormat = 'YYYY-MM-DD'
export const apiDateFormatHourMinute = 'yyyy-MM-dd HH:mm'
export const apiDateFormatFull = 'yyyy-MM-dd HH:mm:ss'
export const apiDateFormatDayMonthYear = 'DD.MM.YYYY'
export const apiDateFormatDayMonthYearHourMinute = 'DD.MM.YYYY HH:mm'
export const apiTimeFormatHourMinute = 'HH:mm'
export const apiTimeFormatHourMinutSecond = 'HH:mm:ss.SSSSSS'
export const apiDateFormatTimeDate = 'HH:mm DD MMM'

export const API_DATE_FORMAT_HOUR_MINUTE_SECOND = 'YYYY-MM-DD HH:mm:ss'

export const localDateFormat = 'DD-MM-YYYY'
